import * as React from "react";
import { Link, Trans, useI18next } from "gatsby-plugin-react-i18next";
import { externalUrlsByLocale } from "../utils/constants";
import { Locales } from "../../locales/languages";

const FooterSection = ({ footerImage }: { footerImage: string }) => {
  const { language } = useI18next();

  return (
    <>
      <footer className="footer relative z-10">
        <div className="container h-full absolute top-0 left-0 right-0 bottom-0">
          <div className="layout-grid z-10">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <div className="w-full">
          <img
            className="w-full"
            srcSet="/images/oval_BG_down@2x.webp 2x, /images/oval_BG_down.webp 1x"
            src="/images/oval_BG_down.webp"
            width="1600"
            height="235"
            alt="oval-top"
          />
        </div>
        <div className="space-custom"></div>
        <div className="absolute top-0 left-0 right-0 bottom-0 -z-10">
          <img
            className="image-cover"
            srcSet={footerImage}
            src="/images/footer-bg.webp"
            width="1600"
            height="541"
            alt="footer-bg"
          />
        </div>
        <div className="container sc-up-mt pb-70 relative">
          <div className="flex flex-col items-center">
            <a href="#home" className="block  w-156 h-22 md:w-227 md:h-32">
              <img
                className="image-sd"
                src="/images/Logo footer.svg"
                width="226"
                height="32"
                alt="milkomeda-logo"
              />
            </a>
            <nav className="main-nav first-row text-menu-white">
              <ul className="-mx-15 flex flex-col items-center lg:flex-row">
                <li className="block w-full">
                  <a
                    href={externalUrlsByLocale.milkomedaDocDeveloperCardano[language as Locales]}
                    target="_blank"
                    rel="noopener"
                    className="main-nav-link"
                  >
                    <Trans>Build</Trans>
                  </a>
                </li>
                <li className="block w-full">
                  <a
                    href={externalUrlsByLocale.milkomedaDocUserCardano[language as Locales]}
                    target="_blank"
                    rel="noopener"
                    className="main-nav-link"
                  >
                    <Trans>Use Milkomeda</Trans>
                  </a>
                </li>
                <li className="block w-full">
                  <Link to="/dapp-store" className="main-nav-link">
                    <Trans>DApp Store</Trans>
                  </Link>
                </li>
                <li className="block w-full">
                  <Link to="/community" className="main-nav-link">
                    <Trans>Community</Trans>
                  </Link>
                </li>
                <li className="block w-full">
                  <a
                    href="https://medium.com/@milkomedafoundation"
                    target="_blank"
                    rel="noopener"
                    className="main-nav-link"
                  >
                    <Trans>Blog</Trans>
                  </a>
                </li>
                <li className="block w-full">
                  <Link to="/support" className="main-nav-link">
                    <Trans>Support</Trans>
                  </Link>
                </li>
                <li className="block w-full">
                  <Link to="/incubator" className="main-nav-link">
                    <Trans>Milkomeda Incubator</Trans>
                  </Link>
                </li>
                <li className="block w-full">
                  <Link to="/contact" className="main-nav-link">
                    <Trans>Contact</Trans>
                  </Link>
                </li>
                <li className="block w-full">
                  <a
                    href="https://dcspark-public-assets.s3.amazonaws.com/brand/Milkomeda%20assets.zip"
                    target="_blank"
                    rel="noopener"
                    className="main-nav-link whitespace-nowrap"
                    download
                  >
                    <Trans>Brand assets</Trans>
                  </a>
                </li>
              </ul>
            </nav>
            <nav className="main-nav second-row text-menu-white">
              <ul className="-mx-15 flex flex-col items-center md:flex-row">
                <li className="block w-full">
                  <a
                    className="main-nav-link whitespace-nowrap"
                    href="/docs/Milkomeda-audit-by-ArbitraryExecution.pdf"
                    target="_blank"
                    rel="noopener"
                    download
                  >
                    <Trans>ArbitraryExecution's Audit</Trans>
                  </a>
                </li>
                <li className="block w-full">
                  <a
                    className="main-nav-link whitespace-nowrap"
                    href="/docs/Milkomeda-audit-by-Certik.pdf"
                    target="_blank"
                    rel="noopener"
                    download
                  >
                    <Trans>Certik's Audit</Trans>
                  </a>
                </li>
                <li className="block w-full">
                  <a
                    className="main-nav-link whitespace-nowrap"
                    href="/docs/formal-Verification-Report-of-dcSpark-SidechainBridge.pdf"
                    target="_blank"
                    rel="noopener"
                    download
                  >
                    <Trans>Certora's Audit</Trans>
                  </a>
                </li>
                <li>
                  <Link to="/terms-of-use" className="main-nav-link whitespace-nowrap">
                    <Trans>Terms of Use</Trans>
                  </Link>
                </li>
              </ul>
            </nav>
            <ul className="flex items-center -mx-7">
              <li className="px-7">
                <a
                  href="https://twitter.com/Milkomeda_com"
                  target="_blank"
                  rel="noopener"
                  title="Twitter"
                  className="flex items-center justify-center w-32 h-32 rounded-full text-bg-blue bg-blue-bg transition hover:bg-blue-bg-light"
                >
                  <svg
                    className="w-16 h-16 fill-current"
                    viewBox="0 0 16 16"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0.999756 12.6387C2.34868 13.4982 3.95096 14 5.67225 14C11.3315 14 14.5288 9.2492 14.336 4.98821C14.9315 4.56153 15.4484 4.02818 15.8569 3.42009C15.31 3.661 14.7226 3.82391 14.1064 3.89684C14.7354 3.52277 15.2188 2.92883 15.4462 2.22096C14.8573 2.56818 14.205 2.82034 13.511 2.9564C12.955 2.36754 12.1628 2 11.2859 2C9.31854 2 7.87251 3.82464 8.3168 5.71966C5.7836 5.5934 3.53734 4.38737 2.03436 2.55403C1.23559 3.91607 1.62001 5.69753 2.97769 6.59914C2.47791 6.58354 2.00734 6.44676 1.59664 6.21999C1.56378 7.62375 2.57539 8.93608 4.0415 9.22888C3.61218 9.34498 3.14234 9.37111 2.66519 9.2804C3.05253 10.4846 4.1784 11.3597 5.51235 11.3844C4.23133 12.3829 2.617 12.8284 0.999756 12.6387Z"
                    />
                  </svg>
                  <span className="hidden">
                    <Trans>Twitter</Trans>
                  </span>
                </a>
              </li>
              <li className="px-7">
                <a
                  href="https://discord.gg/6zY6sybPEk"
                  target="_blank"
                  rel="noopener"
                  title="Discord"
                  className="flex items-center justify-center w-32 h-32 rounded-full text-bg-blue bg-blue-bg transition hover:bg-blue-bg-light"
                >
                  <svg
                    className="w-16 h-16 fill-current"
                    viewBox="0 0 16 16"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M13.3179 2.99346C12.2985 2.52418 11.222 2.19043 10.1159 2.00074C10.1059 1.99865 10.0955 1.99991 10.0863 2.00431C10.0771 2.00871 10.0696 2.01603 10.0649 2.02512C9.91823 2.29074 9.78511 2.56365 9.66608 2.84278C8.47418 2.66109 7.26162 2.66109 6.06971 2.84278C5.95019 2.56274 5.81481 2.28974 5.6642 2.02512C5.65956 2.01603 5.65205 2.00871 5.64284 2.00431C5.63363 1.99991 5.62323 1.99865 5.61324 2.00074C4.50729 2.191 3.4309 2.52472 2.41129 2.99346C2.40657 2.99473 2.40217 2.99696 2.39836 3.00001C2.39455 3.00306 2.3914 3.00686 2.38913 3.01118C0.350521 6.05802 -0.20788 9.02951 0.0646729 11.9656C0.0670446 11.9805 0.0749594 11.9939 0.0868317 12.0032C1.27349 12.8852 2.60117 13.5596 4.01337 13.9975C4.02331 14.0006 4.03395 14.0005 4.04385 13.9973C4.05375 13.9942 4.06245 13.988 4.06877 13.9798C4.37402 13.5644 4.64383 13.1241 4.87535 12.6636C4.87862 12.6574 4.88052 12.6506 4.88093 12.6436C4.88134 12.6366 4.88025 12.6297 4.87773 12.6231C4.87521 12.6166 4.87132 12.6107 4.86632 12.6059C4.86132 12.601 4.85533 12.5972 4.84876 12.5949C4.42526 12.4314 4.01486 12.2358 3.62116 12.0099C3.61431 12.0052 3.6087 11.9989 3.60482 11.9916C3.60094 11.9842 3.59892 11.9761 3.59892 11.9678C3.59892 11.9595 3.60094 11.9513 3.60482 11.944C3.6087 11.9366 3.61431 11.9303 3.62116 11.9257L3.86491 11.7351C3.87237 11.7299 3.88127 11.727 3.89039 11.727C3.89951 11.727 3.90841 11.7299 3.91587 11.7351C5.15291 12.3155 6.50257 12.6164 7.869 12.6164C9.23543 12.6164 10.5851 12.3155 11.8221 11.7351C11.8297 11.7301 11.8386 11.7275 11.8476 11.7275C11.8567 11.7275 11.8655 11.7301 11.8731 11.7351C11.9529 11.8016 12.0349 11.8658 12.1168 11.9279C12.1237 11.9326 12.1293 11.9388 12.1332 11.9462C12.1371 11.9535 12.1391 11.9617 12.1391 11.97C12.1391 11.9783 12.1371 11.9865 12.1332 11.9938C12.1293 12.0011 12.1237 12.0074 12.1168 12.0121C11.7247 12.2404 11.3141 12.4354 10.8892 12.5949C10.8828 12.5977 10.877 12.6019 10.8722 12.607C10.8674 12.6121 10.8636 12.6182 10.8611 12.6248C10.8586 12.6314 10.8575 12.6384 10.8578 12.6454C10.858 12.6525 10.8597 12.6594 10.8627 12.6658C11.0993 13.1201 11.3681 13.557 11.667 13.9731C11.6733 13.9814 11.682 13.9875 11.6919 13.9907C11.7018 13.9939 11.7125 13.9939 11.7224 13.9909C13.1374 13.5546 14.4675 12.8802 15.6556 11.9966C15.6618 11.9925 15.6669 11.9869 15.6704 11.9803C15.6739 11.9737 15.6757 11.9664 15.6756 11.9589C16.0001 8.79377 15.1708 5.61789 13.34 3.01561C13.3383 3.01047 13.3354 3.0058 13.3315 3.00195C13.3277 2.99811 13.323 2.9952 13.3179 2.99346ZM5.2587 10.1796C4.48314 10.1796 3.84496 9.46604 3.84496 8.59298C3.84496 7.71993 4.46984 7.0042 5.2587 7.0042C6.04755 7.0042 6.68351 7.72214 6.67243 8.59077C6.66135 9.45939 6.04533 10.1796 5.2587 10.1796ZM10.486 10.1796C9.7104 10.1796 9.07223 9.46604 9.07223 8.59298C9.07223 7.71993 9.6971 7.0042 10.486 7.0042C11.2748 7.0042 11.9108 7.72214 11.8997 8.59077C11.8886 9.45939 11.2792 10.1796 10.486 10.1796Z" />
                  </svg>
                  <span className="hidden">
                    <Trans>Discord</Trans>
                  </span>
                </a>
              </li>
              {/* <li className="px-7">
                <a
                  href="https://t.me/dcSpark"
                  target="_blank"
                  rel="noopener"
                  title="Telegram"
                  className="group flex items-center justify-center w-32 h-32 rounded-full text-bg-blue bg-blue-bg transition hover:bg-blue-bg-light"
                >
                  <svg
                    className="w-16 h-16 fill-current"
                    viewBox="0 0 16 16"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M12.0573 13.8687C12.1531 13.9364 12.2642 13.9794 12.3806 13.9941C12.4971 14.0088 12.6153 13.9946 12.725 13.9529C12.8344 13.9117 12.9318 13.844 13.0085 13.7558C13.0852 13.6675 13.1387 13.5616 13.1641 13.4476C13.6815 10.9932 14.9508 4.77294 15.4381 2.57119C15.4553 2.48801 15.4499 2.40175 15.4224 2.32137C15.3949 2.24099 15.3464 2.16944 15.282 2.11417C15.2175 2.05889 15.1393 2.02191 15.0557 2.00707C14.9721 1.99223 14.886 2.00007 14.8064 2.02978C12.2678 2.93214 4.50155 5.84974 1.32527 7.0228C1.22771 7.05914 1.14395 7.12507 1.0857 7.21136C1.02745 7.29765 0.997638 7.39999 1.00042 7.50406C0.998725 7.61207 1.03253 7.71766 1.09665 7.8046C1.16077 7.89154 1.25165 7.95503 1.35535 7.98531C2.78107 8.41243 4.65194 9.00798 4.65194 9.00798C4.65194 9.00798 5.52422 11.5947 5.98141 12.9603C6.00751 13.044 6.05425 13.1199 6.11732 13.1808C6.18039 13.2418 6.25777 13.2859 6.34235 13.3092C6.42771 13.3297 6.51679 13.3289 6.60176 13.3069C6.68673 13.2848 6.76498 13.2423 6.82962 13.1829L8.69449 11.4263C8.69449 11.4263 10.8421 13.0024 12.0573 13.8687ZM5.44 8.64704L6.45064 11.9797L6.67923 9.86822L12.7972 4.3759C12.8259 4.34478 12.8419 4.30397 12.8419 4.2616C12.8419 4.21924 12.8259 4.17842 12.7972 4.1473C12.772 4.11364 12.7347 4.09107 12.6932 4.08434C12.6517 4.07761 12.6092 4.08724 12.5746 4.11121L5.44 8.64704Z"
                    />
                  </svg>
                  <span className="hidden">
                    <Trans>Telegram</Trans>
                  </span>
                </a>
              </li> */}
              {/*<li className="px-7">*/}
              {/*  <a*/}
              {/*    href="https://dcspark.gitbook.io/milkomeda"*/}
              {/*    target="_blank"*/}
              {/*    rel="noopener"*/}
              {/*    title="GitBook"*/}
              {/*    className="group flex items-center justify-center w-32 h-32 rounded-full text-bg-blue bg-blue-bg transition hover:bg-blue-bg-light"*/}
              {/*  >*/}
              {/*    <svg*/}
              {/*      className="w-16 h-16 fill-current mt-6"*/}
              {/*      viewBox="0 0 16 16"*/}
              {/*      xmlns="http://www.w3.org/2000/svg"*/}
              {/*    >*/}
              {/*      <path*/}
              {/*        fillRule="evenodd"*/}
              {/*        clipRule="evenodd"*/}
              {/*        d="M7.20181 9.62923C7.45176 9.62923 7.67671 9.82919 7.67671 10.1041C7.67671 10.3541 7.47675 10.579 7.20181 10.579C6.95186 10.579 6.72691 10.3791 6.72691 10.1041C6.72691 9.82919 6.95186 9.62923 7.20181 9.62923ZM14.5503 6.72983C14.3004 6.72983 14.0754 6.52987 14.0754 6.25493C14.0754 6.00498 14.2754 5.78002 14.5503 5.78002C14.8002 5.78002 15.0252 5.97998 15.0252 6.25493C15.0252 6.50487 14.8002 6.72983 14.5503 6.72983ZM14.5503 4.80522C13.7505 4.80522 13.1006 5.45509 13.1006 6.25493C13.1006 6.40489 13.1256 6.55486 13.1756 6.70483L8.40156 9.25431C8.12662 8.85439 7.67671 8.62944 7.20181 8.62944C6.65192 8.62944 6.15203 8.95437 5.90208 9.42927L1.60296 7.17973C1.15305 6.92979 0.803125 6.20494 0.853115 5.50508C0.87811 5.15515 1.00308 4.88021 1.17805 4.78023C1.30302 4.70524 1.428 4.73024 1.60296 4.80522L1.62796 4.83022C2.77772 5.4301 6.50195 7.37969 6.65192 7.45468C6.90187 7.55466 7.02684 7.60465 7.45176 7.40469L15.1502 3.40551C15.2751 3.35552 15.4001 3.25554 15.4001 3.08058C15.4001 2.85562 15.1752 2.75564 15.1752 2.75564C14.7253 2.55569 14.0504 2.23075 13.4005 1.93081C12.0008 1.28095 10.4012 0.531102 9.70129 0.156179C9.10142 -0.168754 8.60152 0.106189 8.52654 0.156179L8.35157 0.231164C5.17723 1.83083 0.978089 3.90541 0.728141 4.05538C0.303228 4.30533 0.0282844 4.83022 0.00328955 5.48008C-0.0467002 6.50487 0.478192 7.57965 1.22804 7.95458L5.7771 10.3041C5.87708 11.0039 6.50195 11.5538 7.20181 11.5538C8.00165 11.5538 8.62652 10.929 8.65151 10.1291L13.6505 7.42968C13.9004 7.62964 14.2254 7.72962 14.5503 7.72962C15.3501 7.72962 16 7.07976 16 6.27992C16 5.45509 15.3501 4.80522 14.5503 4.80522Z"*/}
              {/*      />*/}
              {/*    </svg>*/}
              {/*    <span className="hidden">*/}
              {/*      <Trans>GitBook</Trans>*/}
              {/*    </span>*/}
              {/*  </a>*/}
              {/*</li>*/}
            </ul>

            <a
              href="https://svs.gsfc.nasa.gov/vis/a010000/a010600/a010687/index.html"
              target="_blank"
              rel="noopener"
              className="md:w-2/4 mt-50 text-center text-menu-white text-12"
            >
              <Trans>
                Video made by NASA/Goddard Space Flight Center and the Advanced Visualization
                Laboratory at the National Center for Supercomputing Applications, B. Robertson, L.
                Hernquist
              </Trans>
            </a>
          </div>
        </div>
      </footer>
    </>
  );
};

export default FooterSection;
